import { enUS } from 'date-fns/locale';
import { useCallback } from 'react';
import type { RangeKeyDict } from 'react-date-range';
import { DateRangePicker } from 'react-date-range';

import { useGetStaticRanges } from '../hooks/useGetStaticRanges';
import { FiscalYearRange } from './FiscalYearRange';

interface IProps {
  range: {
    startDate: Date;
    endDate: Date;
  };
  onChange: (props: { startDate: Date; endDate: Date }) => void;
}

export const DateRange = ({ range, onChange }: IProps) => {
  const staticRanges = useGetStaticRanges();

  const handleSelect = useCallback(
    (ranges: RangeKeyDict) => {
      ranges.selection.startDate &&
        ranges.selection.endDate &&
        onChange({
          startDate: ranges.selection.startDate,
          endDate: ranges.selection.endDate,
        });
    },
    [onChange],
  );

  return (
    <DateRangePicker
      onChange={handleSelect}
      locale={enUS}
      months={2}
      direction="horizontal"
      maxDate={new Date()}
      ranges={[{ ...range, key: 'selection' }]}
      staticRanges={staticRanges}
      inputRanges={[]}
      calendarFocus="backwards"
      showDateDisplay={false}
      preventSnapRefocus={true}
      renderStaticRangeLabel={({ label }) =>
        label === 'fiscal_year' ? <FiscalYearRange /> : <></>
      }
    />
  );
};
